import './shark-game-results-component.scss';
import {
    AwardedMPS,
    BoardReviewData,
    BridgeSide,
    DirGroup,
    SharkGameResultsPairV2,
    SharkGameResultsTravelerV2,
    TypeShowBoard,
} from '../../app/types';
import { OutputState, outputActions } from '../../slices/outputSlice';
import { S3MyResults, S3TravelerResults } from '../../app-interfaces/s3-board-map';
import { appActions } from '../../slices/appSlice';
import { bridgeWarGui, gameDataHost } from '../../env';
import { classNames } from '../../utils/mixed';
import { contractSuits, suits } from '../shark-board-stats-component/shark-board-stats-component';
import { decompressData } from '../../utils/data-fetch';
import { engineLoadBoardReviewData } from '../../app-interfaces/actions/engineCommands';
import { suitArray } from '../../app-interfaces/shark-game-engine-helper';
import { tableActions } from '../../slices/tableSlice';
import { useAppDispatch, useAppSelector } from '../../app/hooks';
import { useTranslation } from 'react-i18next';
import React, { FunctionComponent, PropsWithChildren, ReactElement, useState } from 'react';
import SharkBoardReviewComponent from '../shark-board-review-component/shark-board-review-component';
import axios from 'axios';
import moment from 'moment';

const SharkGameResultsComponent: FunctionComponent<
    PropsWithChildren<{
        test?: string;
    }>
> = (props) => {
    const { t } = useTranslation();
    const dispatch = useAppDispatch();
    const { children } = props;
    const { table_setForeignBoardReviewData } = tableActions;
    const { app_updateEngineInterfaceState } = appActions;
    const game = useAppSelector((state) => state.table);
    const { sharkGameResultsV2: sharkGameResults } = game;
    const { pid, engineState, engineStateInterface } = useAppSelector((state) => state.app);
    const [showScores, setShowScores] = useState<boolean>(true);
    const [showPair, setShowPair] = useState<SharkGameResultsPairV2 | undefined>(undefined);
    const [showBoard, setShowBoard] = useState<TypeShowBoard | undefined>(undefined);
    const [showBoardReview, setShowBoardReview] = useState<BoardReviewData | undefined>(undefined);
    const [boardSelectOpened, setBoardSelectOpened] = useState(false);
    const [comparisonSelectOpened, setComparisonSelectOpened] = useState(false);
    const [sectionize, setsectionize] = useState<boolean>();
    const [mySection, setMySection] = useState<boolean>();
    // for going back
    const [lastPair, setLastPair] = useState<SharkGameResultsPairV2 | undefined>(undefined);
    const resultLabels = bridgeWarGui ? 'bridgeWarGameResults' : 'sharkGameResults';
    const d = [
        t('boardStats.bridgePosition.n'),
        t('boardStats.bridgePosition.e'),
        t('boardStats.bridgePosition.s'),
        t('boardStats.bridgePosition.w'),
    ];
    const individual = game.sharkGameResultsV2.movement === 'Individual';
    const { Pairs, game_status, Movement, movement, Scoring, scoring,  HostName, sanctioned_game, multiset, master_points_game, strata } = sharkGameResults ?? {};
    const travelerKeys: (keyof SharkGameResultsTravelerV2)[] = bridgeWarGui
        ? ['name', 'l', 'r', `re${'IMP'}`]
        : individual
        ? ['name', 'c', 'd', 'l', 'r', 's', `re${Scoring ?? 'MP'}`, `ru${Scoring ?? 'MP'}`]
        : ['dir', 'name', 'c', 'd', 'l', 'r', 's', `re${Scoring ?? 'MP'}`, `ru${Scoring ?? 'MP'}`];

    const mySectionId = Pairs.find((pair) => getIsMe(pair, pid))?.section_id;

    const deflatePairData = (encodedData: string): SharkGameResultsPairV2 => {
        decompressData(encodedData);
        // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access
        const decompressed = decompressData(encodedData);
        return JSON.parse(decompressed) as unknown as SharkGameResultsPairV2;
    };

    const _movement = Movement ?? movement ?? 'Individual';

    const isMitchel = _movement === 'Mitchell';
    const pairTitle = _movement === 'Individual' ? 'player' : 'pair';

    const fullDetails = game_status === 'complete' || HostName !== undefined || (!sanctioned_game && !multiset) || !engineState.service;

    const allowBoardReview = bridgeWarGui || (fullDetails && !engineState.service);

    const _scoring = Scoring ?? scoring ?? 'MP';
    const isIMP = _scoring === 'IMP';



    const fetchTraveller = (pair: SharkGameResultsPairV2, gid: string) => {
        if (engineStateInterface.boardData[pair.uuid]) {
            setShowPair(engineStateInterface.boardData[pair.uuid].myresults as unknown as SharkGameResultsPairV2);
            return;
        }

        const dataUrl = `${gameDataHost}/${gid}/pairs/${pair.uuid}.json`;
        axios
            .get(dataUrl)
            .then((response) => {
                const responseData =
                    // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access
                    response.data.compression !== undefined
                        ? // eslint-disable-next-line @typescript-eslint/no-unsafe-argument,@typescript-eslint/no-unsafe-member-access
                          deflatePairData(response.data.data as string)
                        : (response.data as unknown as S3MyResults);

                // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access
                dispatch(
                    app_updateEngineInterfaceState({
                        boardData: {
                            ...engineStateInterface.boardData,
                            [pair.uuid]: { myresults: responseData },
                        },
                    }),
                );
                setShowPair(responseData as unknown as SharkGameResultsPairV2);
            })
            .catch((error) => {
                console.error(`S3 bucket failed Error: ${dataUrl}`, error);
            });
    };

    const fetchBoard = async (board: TypeShowBoard, gid: string) => {
        if (engineStateInterface.travellerData[board.bid]) {
            return engineStateInterface.travellerData[board.bid];
        }
        const safeFileName: string = board.bid.toString().replace(/\+/g, '-').replace(/\//g, '_'); // replace '/' with '_'
        const dataUrl = `${gameDataHost}/boards/${safeFileName}__${gid}.json`;
        return axios
            .get(dataUrl)
            .then((response) => {
                const responseData =
                    // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access
                    response.data.compression !== undefined
                        ? // eslint-disable-next-line @typescript-eslint/no-unsafe-argument,@typescript-eslint/no-unsafe-member-access
                          deflatePairData(response.data.data as string)
                        : (response.data as unknown as S3TravelerResults);
                // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access
                dispatch(
                    app_updateEngineInterfaceState({
                        travellerData: {
                            ...engineStateInterface.travellerData,
                            [board.bid]: responseData,
                        },
                    }),
                );
                return responseData;
            })
            .catch((error) => {
                console.error(`S3 bucket failed Error: ${dataUrl}`, error);
            });
    };

    const handleShowPair = (pairId: SharkGameResultsPairV2['uuid']) => () => {
        if (!sharkGameResults) {
            return;
        }

        const { Pairs } = sharkGameResults;
        setShowScores(false);
        setShowBoard(undefined);

        const selectedPair = Pairs !== undefined ? Pairs.find((pair) => pair.uuid === pairId) : undefined;

        if (selectedPair) {
            if (selectedPair.traveler) {
                setShowPair(selectedPair);
            } else {
                fetchTraveller(selectedPair, game.sharkGameResultsV2?.UUID ?? game.sharkGameResultsV2?.game_id);
            }
        }
    };

    const handleShowBoard = (board: TypeShowBoard) => async (e: React.MouseEvent<HTMLButtonElement>) => {
        e.stopPropagation();
        const isLargeGame = !bridgeWarGui && typeof board.bid === 'string';
        if (isLargeGame) {
            await fetchBoard(board, game.sharkGameResultsV2?.UUID ?? game.sharkGameResultsV2?.game_id);
        }
        setLastPair(showPair);
        setShowBoard(board);
    };

    const handleShowBoardReview =
        (board: TypeShowBoard, p_uuid: string, bridgeSide?: BridgeSide) => async (e: React.MouseEvent<HTMLDivElement>) => {
        if (!allowBoardReview) {
            return;
        }
        e.stopPropagation();
            const isLargeGame = !bridgeWarGui && typeof board.bid === 'string';
            if (isLargeGame) {
                await fetchBoard(board, game.sharkGameResultsV2?.UUID ?? game.sharkGameResultsV2?.game_id);
            }
            if (p_uuid) {
                const boardReviewData: BoardReviewData = {
                    boardBid: board.bid ?? board.bn,
                    boardDisplay: board.bn,
                    bridgeSide:bridgeSide,
                    pair: p_uuid,
                    game: game.sharkGameResultsV2?.UUID ?? game.sharkGameResultsV2?.game_id ?? '',
                };
                setShowBoardReview(boardReviewData);
                dispatch(engineLoadBoardReviewData(boardReviewData));
            }
        };

    const handleChangeBoardReview = async (partial: Partial<BoardReviewData>) => {
        const boardReviewData = showBoardReview ? { ...showBoardReview, ...partial } : showBoardReview;
        const isLargeGame = !bridgeWarGui && typeof boardReviewData.boardBid === 'string';
        if (isLargeGame) {
            await fetchBoard(
                {
                    bid: boardReviewData.boardBid,
                    bn: boardReviewData.boardDisplay,
                },
                game.sharkGameResultsV2?.UUID ?? game.sharkGameResultsV2?.game_id,
            );
        }
        setShowBoardReview(boardReviewData);
        setBoardSelectOpened(false);
        setComparisonSelectOpened(false);
        dispatch(engineLoadBoardReviewData(boardReviewData));
    };

    const handleHideBoardReview = () => {
        setShowBoardReview(undefined);
        table_setForeignBoardReviewData(undefined);
    };

    const toggleSectionize = () => {
        setsectionize((_sectionize) => {
            if (_sectionize) {
                setMySection(false);
            }
            return !_sectionize;
        });
    };

    const toggleMySection = () => {
        setMySection((_mySection) => {
            if (!_mySection) {
                setsectionize(true);
            }
            return !_mySection;
        });
    };

    const goBackToScores = () => {
        setShowScores(true);
        setShowBoard(undefined);
        setShowPair(undefined);
        setLastPair(undefined);
    };

    const goBackToPair = () => {
        setShowScores(false);
        setShowBoard(undefined);
        setShowPair(lastPair);
        setLastPair(undefined);
    };

    const formatValues = (
        key: keyof SharkGameResultsPairV2 | keyof SharkGameResultsTravelerV2,
        value: any,
    ): any | string => {
        //(key);
        switch (key) {
            case 'd':
                return bridgeWarGui
                    ? value === 0 || value === 2
                        ? 'Attacker'
                        : 'Defender'
                    : value >= 0
                    ? d[Number(value)]
                    : '-';
            case 'ruMP': {
                return (value as number).toFixed(2) + '%';
            }
            case 'reMP': {
                return (value as number).toFixed(2) + '%';
            }
            case 'ruIMP':
                return (value as number).toFixed(0);
            case 'reIMP':
                return (value as number).toFixed(0);
            case 'r': {
                return value === 0 ? '=' : value > 0 ? `+${value}` : value;
            }
            case 'strata': {
                return value ? (value as number).toFixed(0) : 0;
            }
            case 'master_points': {
                if (typeof value === 'number' || (typeof value === 'string' && !isNaN(Number(value)))) {
                    const num = Number(value);
                    return isFinite(num) ? num.toFixed(2) : '-';
                } else if (typeof value === 'object' && value !== null) {
                    const awardedMPS = value as AwardedMPS;
                    let result = '';
                    if (awardedMPS.black !== undefined) {
                        result += ` ${isFinite(awardedMPS.black) ? 'B:' + awardedMPS.black.toFixed(2) : ''}`;
                    }
                    if (awardedMPS.red !== undefined) {
                        result += ` ${isFinite(awardedMPS.red) ? 'R:' + awardedMPS.red.toFixed(2) : ''}`;
                    }
                    if (awardedMPS.silver !== undefined) {
                        result += ` ${isFinite(awardedMPS.silver) ? 'S:' + awardedMPS.silver.toFixed(2) : ''}`;
                    }
                    if (awardedMPS.gold !== undefined) {
                        result += ` ${isFinite(awardedMPS.gold) ? 'G:' + awardedMPS.gold.toFixed(2) : ''}`;
                    }
                    if (awardedMPS.platinum !== undefined) {
                        result += ` ${isFinite(awardedMPS.platinum) ? 'P:' + awardedMPS.platinum.toFixed(2) : ''}`;
                    }
                    if (awardedMPS.colorless !== undefined) {
                        result += ` ${isFinite(awardedMPS.colorless) ? '' + awardedMPS.colorless.toFixed(2) : ''}`;
                    }
                    return result.trim();
                }
                return '-';
            }
            default:
                return value;
        }
    };

    const getSuit = (suit: string) => {
        const suits: Record<string, string> = {
            s: 'spades',
            d: 'diamonds',
            c: 'clubs',
            h: 'hearts',
        };

        if (suits[suit]) {
            return <span className={`suit ${suits[suit]}`} />;
        }
        return suit;
    };

    const renderTraveler = (
        key: keyof SharkGameResultsTravelerV2,
        traveler: SharkGameResultsTravelerV2,
    ): ReactElement | any => {
        switch (key) {
            case 'name':
                return (
                    <span className="link" onClick={handleShowPair(traveler.uuid)}>
                        {traveler.name}
                    </span>
                );
            case 'c':
                return (
                    <div
                        className={classNames(
                            'contract suit',
                            traveler.c >= 10 ? contractSuits[`${traveler.c}`.substring(1, 2)] : 'passOut',
                        )}
                    >
                        {`${traveler.c}`.substring(1, 2) === '4' && (
                            <div className="notrump">{contractSuits[`${traveler.c}`.substring(1, 2)]}</div>
                        )}
                        <div className="level">{traveler.c > 0 ? `${traveler.c}`.substring(0, 1) : 'Pass out'}</div>
                        <div className="x">{' XX'.substring(0, traveler.x)}</div>
                    </div>
                );
            case 'l':
                return (
                    <div
                        className={classNames(
                            'suit',
                            traveler.l >= 0 ? suits[suitArray[traveler.l].substring(0, 1) as keyof typeof suits] : '',
                        )}
                    >
                        <span className="rank">{traveler.l >= 0 ? suitArray[traveler.l].substring(1) : '-'}</span>
                    </div>
                );
            case 'reIMP':
                return `${formatValues(key, traveler[key])}  (${formatValues('reMP', traveler['reMP'])})`;
            case 'ruIMP':
                return `${formatValues(key, traveler[key])}  (${formatValues('ruMP', traveler['ruMP'])})`;
            default:
                return formatValues(key, traveler[key]);
        }
    };

    const sortByScoring = (a: SharkGameResultsPairV2, b: SharkGameResultsPairV2) => {
        if (!sharkGameResults) {
            return 0;
        }
        const { scoring: Scoring, show_ranks: ShowRanks } = sharkGameResults;
        if (!ShowRanks) {
            if (a.me) {
                return -1;
            }
            if (b.me) {
                return 1;
            }
            const isMe =
                pid &&
                (a.uuid === pid ||
                    (a.p1?.pid && a.p1?.pid === pid) ||
                    (a.p1?.PK && a.p1?.PK === pid) ||
                    (a.p2?.pid && a.p2?.pid === pid) ||
                    (a.p2?.PK && a.p2?.PK === pid));
            if (isMe) {
                return -1;
            }

            const isBMe =
                pid &&
                (b.uuid === pid ||
                    (b.p1?.pid && b.p1?.pid === pid) ||
                    (b.p1?.PK && b.p1?.PK === pid) ||
                    (b.p2?.pid && b.p2?.pid === pid) ||
                    (b.p2?.PK && b.p2?.PK === pid));
            if (isBMe) {
                return 1;
            }
        }
        if (Scoring === 'IMP') {
            return b.ruIMP - a.ruIMP;
        }
        return b.ruMP - a.ruMP;
    };

    const sortByResultScoring = (a: SharkGameResultsTravelerV2, b: SharkGameResultsTravelerV2) => {
        if (!sharkGameResults) {
            return 0;
        }
        const { scoring: Scoring, show_ranks: ShowRanks } = sharkGameResults;
        if (!ShowRanks) {
            if (a.me) {
                return -1;
            }
            if (b.me) {
                return 1;
            }
        }
        if (Scoring === 'IMP') {
            return b.reIMP - a.reIMP;
        }
        return b.reMP - a.reMP;
    };

    const sortByNoOps = (a: SharkGameResultsTravelerV2, b: SharkGameResultsTravelerV2) => {
        return -1;
    };

    const renderGameResultsScores = () => {
        if (!sharkGameResults) {
            return null;
        }
        const {
            Pairs,
        } = sharkGameResults;

        const isAcblGame = master_points_game;
        const _strata = strata ?? [{idx:0}];
        const _showRanks = sharkGameResults.ShowRanks ?? sharkGameResults.show_ranks;
        const isStratified = strata?.length > 1;
        const pairKeys: (keyof SharkGameResultsPairV2)[] = bridgeWarGui
            ? [`ruIMP`, 'ruMP']
            : [`ru${_scoring}`, 'master_points'];
        const individual = _movement === 'Individual';
        let pairs: SharkGameResultsPairV2[][] = [];

        if (isMitchel) {
            pairs = [Pairs.filter((pair) => pair.dir === 'ns'), Pairs.filter((pair) => pair.dir === 'ew')];
        } else if (sectionize) {
            Pairs.forEach((pair) => {
                if (mySection && mySectionId !== pair.section_id) {
                    return;
                }
                if (!pairs[pair.section_id]) {
                    pairs[pair.section_id] = [];
                }
                pairs[pair.section_id].push(pair);
            });
        } else {
            pairs = [Pairs];
        }

        pairs = pairs.filter(Boolean);

        const boardspergame: number = sharkGameResults.game?.num_rounds
            ? sharkGameResults.game.num_rounds * sharkGameResults.game.boards_per_round
            : 0;

        return (
            <>
                {(!bridgeWarGui && !engineState.service) && (
                    <div className="sectionize">
                        {pid && (
                            <button onClick={toggleMySection}>{mySection ? 'All sections' : 'My section only'}</button>
                        )}
                        <button onClick={toggleSectionize}>{sectionize ? 'Hide sections' : 'Show sections'}</button>
                    </div>
                )}
                {pairs.map((_pairs, index) => (
                    <div key={`_pairs-${index}`} className="sharkGameResultsScores">
                        {isMitchel && <h2>{_pairs[0]?.dir}</h2>}
                        {sectionize && <h2>Section {_pairs[0]?.section_id}</h2>}
                        <table className="sharkGameResultsScores-table">
                            <thead className="sharkGameResultsScores-thead">
                                <tr>
                                    {!bridgeWarGui &&
                                        _strata.map((stratum, idx) => {
                                            // Convert 0, 1, 2, ... to A, B, C, ... for the translation key
                                            const rankLetter = String.fromCharCode(65 + idx);
                                            return (
                                                <th
                                                    key={`sharkGameResults.scores.thead.rank${rankLetter}`}
                                                    className={'rank'}
                                                >
                                                    {isStratified
                                                        ? `${rankLetter}`
                                                        : t(`sharkGameResults.scores.thead.rank`)}
                                                </th>
                                            );
                                        })}
                                    {bridgeWarGui && _showRanks && (
                                        <th key={'sharkGameResults.scores.thead.rank'} className={'rank'}>
                                            {t(`sharkGameResults.scores.thead.rank`)}
                                        </th>
                                    )}
                                    <th key={'sharkGameResults.scores.thead.pair'} className={'pair'}>
                                        {t(
                                            bridgeWarGui
                                                ? `Attacker`
                                                : individual
                                                ? `sharkGameResults.scores.thead.player`
                                                : `sharkGameResults.scores.thead.pair`,
                                        )}
                                    </th>
                                    <th key={'sharkGameResults.scores.thead.ruMP'} className={'ruMP'} colSpan={bridgeWarGui ? 2 : 1}>
                                        {t(
                                            bridgeWarGui
                                                ? `bridgeWarGameResults.scores.thead.ruMP`
                                                : `sharkGameResults.scores.thead.ru${_scoring}`,
                                        )}
                                    </th>
                                    {pairKeys.map((key, thIndex) => {
                                        if (isAcblGame && key === 'master_points') {
                                            return (
                                                <th key={`th-${thIndex}`} colSpan={2} className={key}>
                                                    {t(`sharkGameResults.scores.thead.${key}`)}
                                                </th>
                                            );
                                        }
                                    })}
                                    <th className="action" />
                                </tr>
                            </thead>
                            <tbody>
                                {[..._pairs].sort(sortByScoring).map((pair: SharkGameResultsPairV2, trIndex) => {
                                    const isMe = getIsMe(pair, pid);
                                    const missingBoards = pair.boards_played
                                        ? pair.boards_played < boardspergame
                                        : pair.traveler
                                        ? boardspergame > pair.traveler.length
                                        : true;
                                    return (
                                        <tr
                                            key={`tr-${trIndex}`}
                                            className={isMe ? 'isMe' : 'isNotMe'}
                                            onClick={(fullDetails || isMe) && handleShowPair(pair.uuid)}
                                        >
                                            {!bridgeWarGui &&
                                                _strata.map((stratum, idx) => {
                                                    // Convert 0, 1, 2, ... to A, B, C, ... for the translation key

                                                    let content1: string | number, content2: string | number;
                                                    if (isStratified) {
                                                        if (sectionize) {
                                                            content1 = pair.strata?.section[idx]?.rank ?? '';
                                                            content2 = pair.strata?.event[idx]?.rank ?? '';
                                                        } else {
                                                            content1 = pair.strata?.event[idx]?.rank ?? '';
                                                            content2 = pair.strata?.section[idx]?.rank ?? '';
                                                        }
                                                    }
                                                    else {
                                                        content1 = _scoring === 'MP' ? pair.rMP : pair.rIMP;
                                                    }

                                                    return (
                                                        <td
                                                            key={`tr-${trIndex}-td-${idx}`}
                                                            className={classNames('rank', _showRanks ? '' : 'hide')}
                                                        >
                                                            {content1}
                                                            {content2 && <sub> [{content2}]</sub>}
                                                        </td>
                                                    );
                                                })
                                            }
                                            {bridgeWarGui && _showRanks && (
                                                <td key={`tr-${trIndex}-td-${1}`} className="rank">
                                                    `${pair.rMP}`
                                                </td>
                                            )}
                                            <td className="pair">
                                                {missingBoards ? '* ' : ''}
                                                {pair.play_name ?? pair.name ?? pair.p1?.play_name}
                                            </td>
                                            {pairKeys.map((key, tdIndex) => {
                                                if (isAcblGame || key !== 'master_points') {
                                                    return (
                                                        <td key={`tr-${trIndex}-td-${tdIndex}`} className={key}>
                                                            {formatValues(key, pair[key])}
                                                        </td>
                                                    );
                                                }
                                            })}
                                            <td className="action">
                                                {(fullDetails) &&
                                                    <button onClick={handleShowPair(pair.uuid)}>
                                                        {t('sharkGameResults.scores.showPair')}
                                                    </button>
                                                }
                                            </td>
                                        </tr>
                                    );
                                })}
                            </tbody>
                        </table>
                    </div>
                ))}
            </>
        );
    };

    const renderPairThead = (travelerKeys: (keyof SharkGameResultsTravelerV2)[], table: 'pair' | 'board') => {
        return (
            <thead>
                <tr>
                    {travelerKeys.map((key, thIndex) => {
                        switch (key) {
                            // case 'reMP':
                            //     return (
                            //         !bridgeWarGui && (
                            //             <th key={`th-${thIndex}-1`} colSpan={1} className={key}>
                            //                 {t(`${resultLabels}.pair.thead.result`)}
                            //             </th>
                            //         )
                            //     );
                            // case 'ruMP':
                            //     return (
                            //         !bridgeWarGui && (
                            //             <th key={`th-${thIndex}-1`} colSpan={1} className={key}>
                            //                 {t(`${resultLabels}.pair.thead.running`)}
                            //             </th>
                            //         )
                            //     );
                            case 'c':
                                return (
                                    <th key={`th-${thIndex}-1`} colSpan={4} className={key}>
                                        {t(`${resultLabels}.pair.thead.summary`)}
                                    </th>
                                );
                            default:
                                if (!['d', 'l', 'r', 'reIMP', 'ruIMP'].includes(key)) {
                                    return <th key={`th-${thIndex}-1`} className={key} />;
                                }
                                return null;
                        }
                    })}
                </tr>
                <tr>
                    {travelerKeys.map((key, thIndex) => (
                        <th key={`th-${thIndex}-2`} className={key}>
                            {t(`${resultLabels}.${table}.thead.${individual && key === 'name' ? 'player' : key}`)}
                        </th>
                    ))}
                </tr>
            </thead>
        );
    };

    const RenderGameResultsPair = () => {
        if (!showPair) {
            return null;
        }

        const travelerKeys: (keyof SharkGameResultsTravelerV2)[] = bridgeWarGui
            ? ['bn', 'l', 'r', `re${'IMP'}`]
            : individual
            ? ['bn', 'c', 'd', 'l', 'r', 's', `re${_scoring ?? 'MP'}`, `ru${_scoring ?? 'MP'}`]
            : ['bn', 'dir', 'c', 'd', 'l', 'r', 's', `re${_scoring ?? 'MP'}`, `ru${_scoring ?? 'MP'}`];
        return (
            <>
                <div className="header">
                    <button className="back" onClick={showBoardReview ? handleHideBoardReview : goBackToScores} />
                    <div className="info">
                        {<RenderPlayerName playerName={showPair.name ?? showPair.p1.play_name ?? 'Unknown'} />}
                        <div className="select">
                            {showBoardReview?.boardBid && (
                                <RenderSelectBoard bid={showBoardReview.boardBid} bn={showBoardReview.boardDisplay} />
                            )}
                            {showBoardReview && <RenderComparisonSelect />}
                        </div>
                    </div>
                </div>
                <table className={classNames('sharkGameResultsPair v2', showBoardReview && 'hidden')}>
                    {renderPairThead(travelerKeys, 'pair')}
                    <tbody>
                        {[...(showPair.traveler || [])]
                            .sort((a, b) => {
                                return a.bn - b.bn;
                            })
                            .map((traveler, trIndex) => (
                                <tr
                                    key={`tr-${trIndex}`}
                                    className={'isNotMe'}
                                    onClick={handleShowBoardReview(
                                        { bn: traveler.bn, bid: traveler.bid ?? traveler.bn },
                                        showPair?.uuid,
                                        showPair.dir
                                    )}
                                >
                                    {travelerKeys.map((key, tdIndex) => (
                                        <td key={`tr-${trIndex}-td-${tdIndex}`} className={key}>
                                            {renderTraveler(key, { ...traveler })}
                                        </td>
                                    ))}
                                    <td className="action">
                                        {(fullDetails || getIsMe(showPair, pid)) &&
                                            <button
                                                onClick={handleShowBoard({
                                                    bn: traveler.bn,
                                                    bid: traveler.bid ?? traveler.bn,
                                                })}
                                            >
                                                {t(
                                                    bridgeWarGui
                                                        ? 'bridgeWarGameResults.pair.showBoard'
                                                        : 'sharkGameResults.pair.showBoard',
                                                )}{' '}
                                                {traveler.bn}
                                            </button>
                                        }
                                    </td>
                                </tr>
                            ))}
                    </tbody>
                </table>
            </>
        );
    };

    const RenderBoardResultsHeader = () => {
        const sh = showBoard;
        return (
            <>
                <div className="header">
                    <button className="back" onClick={goBackToPair} />
                    <div className="info">{<RenderBoardDisplay boardDispaly={showBoard.bn} />}</div>
                </div>
            </>
        );
    };

    const RenderGameResultsBoard = () => {
        if (!sharkGameResults) {
            return null;
        }
        const showingBoardReview = showBoard && showBoardReview !== undefined;
        return (
            <>
                {showingBoardReview ? <RenderGameResultsPair /> : <RenderBoardResultsHeader />}
                {showBoard && <RenderGameResultsBoardTable board={showBoard} selectedPair={lastPair} />}
            </>
        );
    };

    const RenderGameResultsBoardTable = ({
        board,
        selectionData,
        bridgeSide,
        selectedPair,
    }: {
        board: TypeShowBoard;
        selectionData?: { uuid?: SharkGameResultsTravelerV2['uuid'] | undefined };
        selectedPair?: SharkGameResultsPairV2;
        bridgeSide?: BridgeSide;
    }) =>
    {
        const isLargeGame = !bridgeWarGui && typeof board.bid === 'string';
        let travelers: SharkGameResultsTravelerV2[] = [];

        if (isLargeGame) {
            travelers = engineStateInterface.travellerData[board.bid];
        } else {
            travelers = (Pairs ?? []).reduce((prev: SharkGameResultsTravelerV2[], next) => {
                const { traveler, name, uuid, me, p1, p2 } = next;

                return [
                    ...prev,
                    ...traveler
                        .filter((travelerData) => travelerData.bn === board.bn)
                        .map((travelerData) => ({
                            ...travelerData,
                            name: name ?? p1?.play_name,
                            uuid,
                            me:
                                travelerData.me ?? pid
                                    ? uuid === pid
                                        ? true
                                        : p1?.pid && p1?.pid === pid
                                        ? true
                                        : p1?.PK && p1?.PK === pid
                                        ? true
                                        : p2?.pid && p2?.pid === pid
                                        ? true
                                        : p2?.PK && p2?.PK === pid
                                    : false,
                        })),
                ];
            }, []);
        }

        const dirFromBridgeSide = (side?: BridgeSide): BridgeSide | undefined => {
            if (!side) {
                return undefined;
            }
            // Adjust these mappings to your actual BridgeSide values
            if (side === 'ns') {
                return 'ns';
            }
            if (side === 'ew') {
                return 'ew';
            }
            return undefined;
        };

        const forcedDir = dirFromBridgeSide(bridgeSide);

        const travelersEWNatural = [...travelers].filter((t) => t.dir === 'ew');
        const travelersEW = travelersEWNatural.sort(travelersEWNatural.length > 2 ? sortByResultScoring : sortByNoOps);


        const travelersNSNatural = [...travelers].filter((t) => t.dir === 'ns');
        const travelersNS = travelersNSNatural.sort(travelersNSNatural.length > 2 ? sortByResultScoring : sortByNoOps);

        const groups: DirGroup[] = forcedDir
            ? forcedDir === 'ns'
                ? [{ dir: 'ns', travelers: travelersNS }]
                : [{ dir: 'ew', travelers: travelersEW }]
            : [
                  ...(travelersNS.length ? [{ dir: 'ns' as const, travelers: travelersNS }] : []),
                  ...(travelersEW.length ? [{ dir: 'ew' as const, travelers: travelersEW }] : []),
              ];

        // Keep allTravelers aligned with what you render (recommended)
        const allTravelers =
            forcedDir === 'ns' ? travelersNS : forcedDir === 'ew' ? travelersEW : [...travelersNS, ...travelersEW];

        const selectedUUID = allTravelers.some((t) => t.uuid === selectedPair?.uuid)
            ? selectedPair?.uuid
            : allTravelers[0]?.uuid;
        const myTravellerUUID = allTravelers.find((t) => pid && t.uuid.includes(pid))?.uuid ?? '';

        return (
            <div>
                {groups.map((group) => (
                    <table
                        key={group.dir}
                        className={classNames('sharkGameResultsBoards v2', showBoardReview && 'hidden')}
                    >
                        {renderPairThead(travelerKeys, 'board')}
                        <tbody>
                            {group.travelers.map((traveler, trIndex) => {
                                return (
                                    <tr
                                        key={`${group.dir}-tr-${trIndex}`}
                                        className={classNames(
                                            ((!selectedUUID && trIndex === 0) || selectedUUID === traveler.uuid) &&
                                                `selected`,
                                            traveler.uuid === myTravellerUUID ? 'isMe' : 'isNotMe',
                                        )}
                                        onClick={
                                            selectionData
                                                ? comparisonSelectOpened
                                                    ? () => handleChangeBoardReview({ comparisonUuid: traveler.uuid })
                                                    : () => setComparisonSelectOpened(true)
                                                : handleShowBoardReview(
                                                      { bn: traveler.bn, bid: traveler.bid },
                                                      traveler.uuid,
                                                      traveler.dir
                                                  )
                                        }
                                    >
                                        {travelerKeys.map((key, tdIndex) => {
                                            return (
                                                <td key={`${group.dir}-tr-${trIndex}-td-${tdIndex}`} className={key}>
                                                    {renderTraveler(key, traveler)}
                                                </td>
                                            );
                                        })}
                                    </tr>
                                );
                            })}
                        </tbody>
                    </table>
                ))}
            </div>
        );
    };

    const RenderSelectBoard = (board: TypeShowBoard) => {
        return (
            <div className={classNames('select-board', boardSelectOpened && 'opened')}>
                {[...(showPair?.traveler || [])]
                    .sort((a, b) => {
                        return a.bn - b.bn;
                    })
                    .map((traveler) =>
                        // eslint-disable-next-line react/prop-types
                        traveler.bn === board.bn ? (
                            <div
                                key={`${traveler.name}-tr-${traveler.bn}`}
                                className="current-board"
                                onClick={() => setBoardSelectOpened(!boardSelectOpened)}
                            >
                                Board {traveler.bn}
                            </div>
                        ) : (
                            <div
                                key={`${traveler.name}-tr-${traveler.bn}`}
                                onClick={() =>
                                    handleChangeBoardReview({
                                        boardBid: traveler?.bid ?? traveler.bn,
                                        boardDisplay: traveler.bn,
                                    })
                                }
                            >
                                Board {traveler.bn}
                            </div>
                        ),
                    )}
            </div>
        );
    };

    const RenderPlayerName = ({ playerName }: { playerName: string }) => {
        return <div className="current-player">{playerName}</div>;
    };

    const RenderBoardDisplay = ({ boardDispaly }: { boardDispaly: number }) => {
        return <div className="current-player">Board {boardDispaly}</div>;
    };

    const RenderComparisonSelect = () => {
        //ToDo Before we render, make a request for the board data
        const compareToPairUuid = showBoardReview?.comparisonUuid;
        return showBoardReview?.boardBid ? (
            <div className={classNames('select-comparison', comparisonSelectOpened && 'opened')}>
                <RenderGameResultsBoardTable
                    board={{ bid: showBoardReview.boardBid, bn: showBoardReview.boardDisplay }}
                    selectionData={{
                        uuid: compareToPairUuid,
                    }}
                    bridgeSide={showBoardReview.bridgeSide}
                />
            </div>
        ) : null;
    };
    const isAcblGame = sharkGameResults.master_points_game && !sharkGameResults.sanctioned_game;
    const hostName = sharkGameResults.host_name ?? sharkGameResults.HostName;
    const updatedON = sharkGameResults.updated_time_stamp ?? sharkGameResults.TimeStamp;
    const startedON = sharkGameResults.game?.scheduled_start_unix_time ?? sharkGameResults.updated_time_stamp;
    return (
        <section className="SharkGameResultsComponent">
            {sharkGameResults && (
                <h1>
                    <span>{sharkGameResults.event_name ?? sharkGameResults.EventName}</span>
                    <span></span>
                    {bridgeWarGui && (
                        <span className="updatedOn">
                        {moment.utc(moment.unix(startedON)).local().format('dddd, MMMM Do YYYY')} /{' '}
                            Entries: {sharkGameResults?.entries ?? 'unknown'}
                    </span>)}
                    {!bridgeWarGui && (
                    <span className="updatedOn">
                        {moment.utc(moment.unix(startedON)).local().format('dddd, MMMM Do YYYY')} /{' '}
                        {sharkGameResults.scoring ?? sharkGameResults.Scoring} /{' '}
                        {sharkGameResults?.movement ?? sharkGameResults?.Movement} /{' '}
                        Entries: {sharkGameResults?.entries ?? 'unknown'}
                    </span>)}
                    {!bridgeWarGui && (
                    <span className="updatedOn">hosted by: {hostName}</span>
                    )}
                    {/*{!bridgeWarGui && isAcblGame && (*/}
                    {/*    <span className="acblGameWarning">{t('sharkGameResults.acblGameWarning')}</span>*/}
                    {/*)}*/}
                    <span className="updatedOn">
                        {t('sharkGameResults.updatedOn')}:{' '}
                        {moment
                            .utc(moment.unix(sharkGameResults.updated_time_stamp ?? sharkGameResults.TimeStamp))
                            .local()
                            .format(t('sharkGameResults.dateTimeFormat'))}
                    </span>
                </h1>
            )}
            {showScores && renderGameResultsScores()}
            {!!showPair && !showBoard && <RenderGameResultsPair />}
            {!!showBoard && <RenderGameResultsBoard />}
            {showBoardReview && (
                <div className="showBoardReview">
                    <SharkBoardReviewComponent isStandAlone />
                </div>
            )}
            {children}
        </section>
    );
};

const getTravellerByUuid = (
    uuid: SharkGameResultsPairV2['uuid'],
    pairs: SharkGameResultsPairV2[],
): SharkGameResultsPairV2 | undefined => {
    return pairs.find((pair) => pair.uuid === uuid);
};

const getIsMe = (pair: SharkGameResultsPairV2, pid: string) => {
    return (
        pair.me ||
        (pid &&
            ((pair.p1?.pid && pair.p1?.pid === pid) ||
                (pair.p1?.PK && pair.p1?.PK === pid) ||
                (pair.p2?.pid && pair.p2?.pid === pid) ||
                (pair.p2?.PK && pair.p2?.PK === pid)))
    );
};

export default SharkGameResultsComponent;
